import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import logo from "../img/CDGNC_25_1800x1800.png";

function HowToSection() {
  return (
    <Container>
      <Row className="justify-content-center align-items-center">
        <Col xs={12} lg={6} className="">
          {/* link to www.kpleagues.com */}
          {/* <a href="https://www.kpleagues.com" target="_blank" rel="noreferrer"> */}
          <img src={logo} alt="dgPutt" className="img-fluid" />
          {/* </a> */}
        </Col>
        <Col xs={12} lg={6}>
          {/* centered header */}
          {/* bold h1 */}
          {/* <h1 style={{ fontWeight: "bold" }} className="text-center mt-3">
            Welcome to dgPutt.net
          </h1> */}
          <hr />
          <h3 className="text-center">Registration</h3>

<ol>
  <li>
    First time? Click{" "}
    <Link to="/auth/signup">
      {""}Create an Account{""}
    </Link>{" "}
    and enter your email.
    {/* "Login with Google" or{" "} */}
  </li>
  <li>
    Already have an account?
    <Link to="/auth/signin"> Login </Link>
  </li>
  <li>Choose the event you are playing from above under "Events"</li>
  <li>Click "Check-In"</li>
  <li>Choose your flight and click "Confirm"</li>
  <li>
    One player on your card will select the names of your cardmates
    from the "available players" list and click create scorecard
  </li>
  <li>Putt!</li>
</ol>

<hr />
          <h3 className="text-center">Putting</h3>
          <ul>
            <li>2 Putts from each station</li>
            <li>20 stations total</li>
            <li>After each putt, tap the corresponding scoring button</li>
            <li>The tee is a flag. Treat the flag like your mini</li>
            <li>One foot must be behind flag (standard lie)</li>
            <li>You may jump/step putt on the 4th (Gold) station for each basket. You may not jump/step on any other tee</li>
            <li>Stations 1-4 play to the first basket. 5-8 play to the second basket. etc...</li>
            <li>Perfect Score: 300</li>
          </ul>
          <hr />

          <h3 className="text-center">Scoring</h3>
          <ul>
            <li>✔️: Putt in or on top of basket</li>
            <li>⛓️: Tap the cage, chains, or top of basket</li>
            <li>🚫: Airball</li>
            <li>Bonus points awarded for making both putts</li>
            <li>Point values increase based on station color</li>
          </ul>
          <hr />

          <h3 className="text-center">Questions?</h3>
          <ul>
            <li>
          Send a message to PK <a href="sms:6512525960">651-252-5960</a>
          </li>
            <li>
            <a href="mailto:pk@pkdiscgolf.com">pk@pkdiscgolf.com</a>
  
            </li>
            <li>
              <a href="https://www.instagram.com/pk_discgolf/">Instagram</a>
            </li>
            </ul>

          
        </Col>
      </Row>
    </Container>
  );
}

export default HowToSection;
